var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.logoUrl)?_c('b-img',{staticClass:"client-logo",attrs:{"src":_vm.logoUrl},on:{"click":function($event){return _vm.$emit('click')}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }